import React, { useState } from 'react';
import { Button, Checkbox, ButtonGroup } from '@chakra-ui/react';

import { Modal, Textarea } from 'shared-components';
import { IMessage } from 'api-paths-cas';

import { UNI_ROLES, ENROLY_AGENT_ROLES, AGENT_ROLES } from '../../../../store/auth/types';

export interface IDispatchProps {
  onClose: () => void;
  onDeleteDoc: (
    message: IMessage,
    sponsorType: string,
    sponsorKey: string | null,
    docType: string | null,
    docKey: string | null,
    reason: string,
    isFinDoc: boolean,
    isFollowUp: boolean,
  ) => void;
}

export interface IProps {
  sponsorType: string;
  docType: string | null;
  sponsorKey: string | null;
  docKey: string | null;
  modalTitle?: string;
  userName: string;
  displayName: string;
  isFinanceDocumentModal: boolean;
  isFollowUpDocumentModal: boolean;
  role: string;
}

type ICustomProps = IProps &
  IDispatchProps & {
    onDelete?: () => void;
  };

const FileDeleteModal = (props: ICustomProps) => {
  const {
    sponsorType,
    docType,
    sponsorKey,
    docKey = null,
    modalTitle = '',
    userName,
    isFinanceDocumentModal,
    isFollowUpDocumentModal,
    role,
  } = props;
  const initialMessage: IMessage = {
    message: '',
    isSendToStudent: true,
    messageType: 'note',
    createdAt: 0,
    author: '',
    authorName: '',
    messageFrom: 'uni',
    messageTo: 'student',
  };
  const [message, setMessage] = useState(initialMessage);
  const [deleteConfirmed, setDeleteConfirmed] = useState(false);

  const submitMessage = () => {
    if (!message || !deleteConfirmed) {
      return;
    }
    const msgTitle = modalTitle;
    const msgReason = message.message ? `Deleted: ${message.message}` : 'Deleted';
    const author = userName || 'Anonymous';
    const newMessage: IMessage = {
      message: `${msgTitle} ${msgReason}`,
      createdAt: Date.now(),
      isSendToStudent: false,
      messageType: 'note',
      author,
      authorName: props.displayName || author,
      messageFrom: 'uni',
      messageTo: 'uni',
      ...(UNI_ROLES.includes(role) ? { uniRead: true } : {}),
      ...(ENROLY_AGENT_ROLES.includes(role) ? { adminRead: true } : {}),
      ...(AGENT_ROLES.includes(role) ? { agentRead: true } : {}),
    };

    props.onDeleteDoc(
      newMessage,
      sponsorType,
      sponsorKey,
      docType,
      docKey,
      message.message,
      isFinanceDocumentModal,
      isFollowUpDocumentModal,
    );

    if (props.onDelete) props.onDelete();
    props.onClose();
  };

  return (
    <Modal
      id={'file-delete'}
      show={true}
      title={`Delete document request reason`}
      onClose={props.onClose}
      footer={
        <ButtonGroup size={'lg'} gap={3}>
          <Button onClick={props.onClose}>Cancel</Button>

          <Button
            id="submit-log-button"
            onClick={submitMessage}
            isDisabled={!deleteConfirmed}
            variant={'solid'}
            colorScheme="red"
          >
            Delete
          </Button>
        </ButtonGroup>
      }
    >
      <Textarea
        id={'message'}
        label="Add note"
        value={message.message}
        onChange={(event: React.FormEvent<HTMLTextAreaElement>) =>
          setMessage({ ...message, message: event.currentTarget.value })
        }
        placeholder={'Type your message here...'}
        mb={3}
      />

      <Checkbox isChecked={deleteConfirmed} onChange={() => setDeleteConfirmed(!deleteConfirmed)} size={'lg'}>
        I understand any uploaded files will be permanently deleted
      </Checkbox>
    </Modal>
  );
};

export default FileDeleteModal;
